"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconPositions = exports.sizes = exports.colors = void 0;
var colors = {
  primary: {
    background: '#FDC300',
    hover: '#fdcf33',
    active: '#e6b201'
  },
  secondary: {
    background: '#FFFFFF',
    border: ' #bbbbbb',
    active: {
      background: '#efefef',
      border: '#99a3ba'
    },
    hover: {
      border: '#99a3ba',
      background: '#f7f7f7'
    }
  },
  tertiary: {
    background: '#FFFFFF',
    hover: '#f7f7f7',
    active: '#efefef'
  },
  disabled: {
    border: '#e5e5e5',
    color: 'rgba(0, 0, 0, 0.2)'
  }
};
exports.colors = colors;
var sizes = {
  lg: {
    width: '100%'
  }
};
exports.sizes = sizes;
var iconPositions = {
  left: {
    "float": 'left',
    marginRight: '6px'
  },
  right: {
    marginLeft: '6px',
    "float": 'right'
  }
};
exports.iconPositions = iconPositions;